var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alert alert-info"},[_vm._v(" "+_vm._s(_vm.$t("THE_LAST_WORKING_DAY_HAS_REMAINED"))+" "+_vm._s(_vm.routemap.minutesToNextControl)+" "+_vm._s(_vm.$t("MINUTES_TO_QUALITY_CONTROL"))+". "),_c('br'),_vm._v(" "+_vm._s(_vm.$t("PLEASE_CHECK_IN_AS_AN_OPERATOR_TO_START_THE_WORK_PROCESS"))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }